/**
 * Карта: список сот в кадре и карточка соты (§Т2.2).
 */

import type { MapHexCard, MapHexesResponse } from "@hive/shared/api/map";

import { apiFetch } from "./client.js";

export type MapBounds = {
  readonly west: number;
  readonly south: number;
  readonly east: number;
  readonly north: number;
};

/** Строка bbox для GET /map/hexes: west,south,east,north. */
export function formatMapBbox(bounds: MapBounds): string {
  return [bounds.west, bounds.south, bounds.east, bounds.north].join(",");
}

/**
 * Зум для запроса кадра. MapLibre держит масштаб дробным, а в URL он нужен
 * устойчивым: иначе каждый щипок пальцем даёт новый адрес и новый запрос.
 */
export function mapZoomParam(zoom: number): number {
  return Number.isFinite(zoom) ? Math.floor(zoom) : 0;
}

export async function fetchHexes(
  bounds: MapBounds,
  zoom: number,
  token: string,
  signal?: AbortSignal,
): Promise<MapHexesResponse> {
  const bbox = formatMapBbox(bounds);
  return apiFetch<MapHexesResponse>(
    `/map/hexes?bbox=${encodeURIComponent(bbox)}&zoom=${mapZoomParam(zoom)}`,
    {
      token,
      ...(signal ? { signal } : {}),
    },
  );
}

export async function fetchHexCard(
  hexId: string,
  token: string,
  signal?: AbortSignal,
): Promise<MapHexCard> {
  return apiFetch<MapHexCard>(`/map/hex/${encodeURIComponent(hexId)}`, {
    token,
    ...(signal ? { signal } : {}),
  });
}
